import React, { startTransition } from 'react';
import { searchAirports } from '../../services/airportApi';

const FULL_MONTHS = 13;
const MONTH_CHUNK = 3;

function loadDefaultAirports() {
  if (typeof searchAirports !== 'function') return Promise.resolve([]);
  const pending = searchAirports('India');
  if (!pending || typeof pending.then !== 'function') return Promise.resolve([]);
  return pending.then((res) => {
    const options = (res.data || [])
      .map((airport) => {
        if (!airport.iataCode) return null;
        return {
          ...airport,
          value: airport.iataCode,
          label: `${airport.name} (${airport.iataCode}) - ${airport.address?.cityName || airport.cityName}, ${airport.address?.countryName || airport.countryName}`,
          cityName: airport.address?.cityName || airport.cityName,
          countryName: airport.address?.countryName || airport.countryName,
        };
      })
      .filter(Boolean);
    const seen = new Set();
    return options.filter((airport) => {
      if (seen.has(airport.iataCode)) return false;
      seen.add(airport.iataCode);
      return true;
    }).slice(0, 20);
  }).catch(() => []);
}

/**
 * Owns the mobile From / To / date sheets so a tap does not re-render FlightForm.
 */
class MobileInteractionHost extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      airportField: null,
      dateOpen: false,
      draftStart: null,
      draftEnd: null,
      dateField: 'departure',
      months: 1,
      options: [],
      loading: false,
    };
    this.growthTimer = null;
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.airportField && this.state.airportField !== prevState.airportField && this.state.options.length === 0) {
      const field = this.state.airportField;
      this.setState({ loading: true });
      loadDefaultAirports().then((options) => {
        if (this.state.airportField !== field) return;
        this.setState({ options, loading: false });
      });
    }
    if (this.state.dateOpen && !prevState.dateOpen) {
      this.cancelMonthGrowth();
      this.growthTimer = window.setTimeout(() => {
        this.scheduleMonthGrowth();
      }, 0);
    }
    if (!this.state.dateOpen && prevState.dateOpen) {
      this.cancelMonthGrowth();
    }
  }

  componentWillUnmount() {
    this.cancelMonthGrowth();
  }

  cancelMonthGrowth = () => {
    if (this.growthTimer != null) {
      window.clearTimeout(this.growthTimer);
      this.growthTimer = null;
    }
  };

  scheduleMonthGrowth = () => {
    this.cancelMonthGrowth();
    const step = () => {
      if (!this.state.dateOpen || this.state.months >= FULL_MONTHS) return;
      const next = this.state.months < 1
        ? 1
        : Math.min(FULL_MONTHS, this.state.months + MONTH_CHUNK);
      this.setState({ months: next }, () => {
        if (this.state.dateOpen && this.state.months < FULL_MONTHS) {
          this.growthTimer = window.setTimeout(step, 50);
        }
      });
    };
    this.growthTimer = window.setTimeout(step, 16);
  };

  openAirport = (field) => {
    this.setState((prev) => ({
      airportField: field,
      dateOpen: false,
      options: prev.options,
      loading: prev.options.length === 0,
    }));
  };

  openDate = (field, snapshot) => {
    this.setState({
      dateOpen: true,
      airportField: null,
      dateField: field || 'departure',
      draftStart: snapshot?.startDate || null,
      draftEnd: snapshot?.endDate || null,
      months: 0,
    });
  };

  setDateField = (field) => {
    this.setState({ dateField: field });
  };

  closeAirport = () => {
    this.setState({ airportField: null });
  };

  closeDate = () => {
    this.cancelMonthGrowth();
    this.setState({ dateOpen: false, months: 0 });
  };

  setDraftStart = (start) => {
    startTransition(() => {
      this.setState({ draftStart: start });
    });
  };

  setDraftEnd = (end) => {
    startTransition(() => {
      this.setState({ draftEnd: end });
    });
  };

  setDraftRange = (start, end) => {
    startTransition(() => {
      this.setState({ draftStart: start, draftEnd: end });
    });
  };

  render() {
    const { airportField, dateOpen } = this.state;
    if (!airportField && !dateOpen) return null;
    return (
      <>
        {airportField && this.props.renderAirport
          ? this.props.renderAirport(airportField, {
            options: this.state.options,
            loading: this.state.loading,
            close: this.closeAirport,
          })
          : null}
        {dateOpen && this.props.renderDate
          ? this.props.renderDate({
            start: this.state.draftStart,
            end: this.state.draftEnd,
            field: this.state.dateField,
            months: this.state.months,
            setStart: this.setDraftStart,
            setEnd: this.setDraftEnd,
            setRange: this.setDraftRange,
            close: this.closeDate,
          })
          : null}
      </>
    );
  }
}

export default MobileInteractionHost;
